import { useTranslation } from '../../../../../utils/useTranslation';
import { WithHint } from '../../../../feedback/Tooltip';
import { IconInfo } from '../../../../icon/IconInfo';
import { Flex } from '../../../../layout/Flex';
import { Price } from '../../../../price/Price';
import { Typography } from '../../../../typography/Typography';
import { AdvertisingProductCardPriceProps } from './types';

export const AdvertisingProductCardPrice: React.FC<AdvertisingProductCardPriceProps> = ({
    offers,
    price,
}) => {
    const t = useTranslation();
    const firstOffer = offers[0];

    if (offers.length > 1) {
        return price ? (
            <Flex direction="row" spacing={0.25} alignItems="center">
                <Typography variant="body" weight="bold">
                    ~
                </Typography>
                <Price
                    pt={0.25}
                    priceInfo={{ currency: 'RUB', integerPart: price }}
                    variant="body"
                />
                <WithHint
                    mt={0.25}
                    message={t(
                        'Ориентировочная розничная цена товара поможет оценить его ценность для вашей аудитории. В 90% магазинов, где мы нашли этот товар, он стоит столько же или дешевле.',
                    )}
                    trigger={<IconInfo color="var(--color-secondary)" cursor="pointer" size={16} />}
                />
            </Flex>
        ) : null;
    }

    return firstOffer.price ? (
        <Price pt={0.25} priceInfo={firstOffer.price} variant="body" />
    ) : null;
};
